import React from "react";
import cn from "classnames";

// Assets
import { ReactComponent as NextIcon } from "assets/next.svg";
import { ReactComponent as PreviousIcon } from "assets/previous.svg";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  isLoading = false,
}) => {
  const handlePrevious = () => {
    if (currentPage > 1 && !isLoading) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages && !isLoading) {
      onPageChange(currentPage + 1);
    }
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex items-center justify-between gap-8 py-2">
      <p className="text-[13px] font-inter text-[#808285]">
        <span className="text-[#252526] font-inter-semibold">
          {currentPage}
        </span>{" "}
        dari{" "}
        <span className="text-[#252526] font-inter-semibold">{totalPages}</span>{" "}
        halaman
      </p>

      <div className="flex items-center gap-2">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1 || isLoading}
          className={cn(
            "flex items-center gap-2 text-[13px] font-inter text-[#252526] bg-[#FAFAFA] rounded-[4px] p-2 border border-solid border-[#DEDFDE] disabled:text-[#D8D8D9] disabled:cursor-not-allowed transition-colors",
            {
              "opacity-30": currentPage === 1 || isLoading,
            },
          )}
        >
          <PreviousIcon
            className={currentPage === 1 || isLoading ? "opacity-30" : ""}
          />
          <span>Sebelumnya</span>
        </button>

        <button
          onClick={handleNext}
          disabled={currentPage === totalPages || isLoading}
          className={cn(
            "flex items-center gap-2 text-[13px] font-inter text-[#252526] bg-[#FAFAFA] rounded-[4px] p-2 border border-solid border-[#DEDFDE] disabled:text-[#D8D8D9] disabled:cursor-not-allowed transition-colors",
            {
              "opacity-30": currentPage === totalPages || isLoading,
            },
          )}
        >
          <span>Selanjutnya</span>
          <NextIcon
            className={
              currentPage === totalPages || isLoading ? "opacity-30" : ""
            }
          />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
